import { GetCollectionFieldsResultData } from '@indigohive/cogfy-types/endpoints/getCollectionFields'
import { MoveDownIcon, MoveUpIcon, EyeIcon, EyeOffIcon, RotateCcw } from 'lucide-react'
import { Menu } from '../../../components'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

export type RecordPageFieldMenuProps = {
  field: GetCollectionFieldsResultData | null
  moveUpDisabled?: boolean
  moveDownDisabled?: boolean
  onHideClick?: () => void
  onShowClick?: () => void
  onMoveUpClick?: () => void
  onMoveDownClick?: () => void
  onRecalculateClick?: () => void
  hasFullAccess?: boolean
}

export function RecordPageFieldMenu (props: RecordPageFieldMenuProps) {
  const {
    field,
    onHideClick,
    onShowClick,
    onMoveUpClick,
    onMoveDownClick,
    onRecalculateClick,
    moveUpDisabled,
    moveDownDisabled,
    hasFullAccess
  } = props
  const { t } = useTranslation()

  return (
    <Menu>
      {field?.visibility === 'hidden' && (
        <li
          onClick={() => hasFullAccess && onShowClick?.()}
          className={clsx(!hasFullAccess && 'menu-disabled')}
        >
          <a>
            <EyeIcon size={16} />
            {t('RecordPage:Show field')}
          </a>
        </li>
      )}
      {field?.visibility === 'visible' && (
        <li
          onClick={() => hasFullAccess && onHideClick?.()}
          className={clsx(!hasFullAccess && 'menu-disabled')}
        >
          <a>
            <EyeOffIcon size={16} />
            {t('RecordPage:Hide field')}
          </a>
        </li>
      )}
      <li
        onClick={() => (hasFullAccess && !moveUpDisabled) && onMoveUpClick?.()}
        className={clsx((!hasFullAccess || moveUpDisabled) && 'menu-disabled')}
      >
        <a>
          <MoveUpIcon size={16} />
          {t('RecordPage:Move up')}
        </a>
      </li>
      <li
        onClick={() => (hasFullAccess && !moveDownDisabled) && onMoveDownClick?.()}
        className={clsx((!hasFullAccess || moveDownDisabled) && 'menu-disabled')}
      >
        <a>
          <MoveDownIcon size={16} />
          {t('RecordPage:Move down')}
        </a>
      </li>
      <li
        onClick={() => onRecalculateClick?.()}
        className={clsx((!hasFullAccess || moveDownDisabled || !onRecalculateClick) && 'disabled')}
      >
        <a>
          <RotateCcw size={16}/>
          {t('fieldCell:Recalculate cell')}
        </a>
      </li>
    </Menu>
  )
}
